import { Description } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';

const iconMap = {
	Lage: 'locationFilled',
	Ausstattung: 'equipment',
	Zimmer: 'room2',
	'Sport/Entertainment': 'entertainment',
	Verpflegung: 'catering',
	Kreditkarten: 'card',
} as const;

type IconMap = typeof iconMap;

export function descriptionToItemProps(description: Description) {
	let icon = 'asterisk';
	if (description.Title in iconMap) {
		icon = iconMap[description.Title as keyof IconMap];
	}
	return {
		icon,
		title: description.Title,
		text: description.Text,
	};
}
